module.exports = __webpack_public_path__ + "static/media/2.2215caa.mp3";


//////////////////
// WEBPACK FOOTER
// ./src/assets/2.mp3
// module id = FAwa
// module chunks = 1